import { IconProps } from "../../types/IconType";

const ArrowForwardIcon = ({ width, height, color = "#333236" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_forward_ios_FILL0_wght300_GRAD0_opsz24 3">
        <path
          id="Vector"
          d="M7.64075 9.99872L13.918 16.276C14.0836 16.4416 14.1643 16.6387 14.16 16.8673C14.1557 17.0959 14.0708 17.2931 13.9052 17.4586C13.7396 17.6242 13.5425 17.707 13.3139 17.707C13.0852 17.707 12.8881 17.6242 12.7225 17.4586L6.3427 11.066C6.19206 10.9154 6.08042 10.7466 6.00777 10.5596C5.93513 10.3726 5.89881 10.1857 5.89881 9.99872C5.89881 9.81176 5.93513 9.62479 6.00777 9.43782C6.08042 9.25086 6.19207 9.08206 6.3427 8.93143L12.7353 2.5388C12.9009 2.37321 13.0959 2.29254 13.3203 2.2968C13.5446 2.30108 13.7396 2.38602 13.9052 2.55161C14.0708 2.71721 14.1536 2.91432 14.1536 3.14295C14.1536 3.37157 14.0708 3.56868 13.9052 3.73428L7.64075 9.99872Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ArrowForwardIcon;
